const getPullLogStatus = (char = "") => {
  const statusMap = {
    C: "Pull Successfull",
    P: "Pending",
    I: "In Progress",
    F: "Failed",
  };

  return statusMap[char] || "Unknown"; // Default to "Unknown" if char is not in the map
};

export default getPullLogStatus;

export const ReqFieldLabel = () => <span className="text-danger">*</span>;
